<template>
  <div class="main">
    <div class="monthyear">
      <div class="month">
        <div class="dec" @click="monthInc( -1 )"></div>
        <div
          class="val"
          :class="month == dateCur.month ? 'current' : ''"

          @click="selector='months'"
        >
          {{ monthNames[ month - 1 ] }}
          <transition
            name="selector"
          >
            <div class="selector months" ref="months" v-show="selector=='months'">
              <template v-for="n in [ 1, 7, 2, 8, 3, 9, 4, 10, 5, 11, 6, 12 ]">
                <div
                  :class="n == dateCur.month ? 'current' : ''"
                  @click.stop="monthSet( n )"
                >
                  <span>{{ pad2( n ) + "." }}</span>{{ monthNames[ n - 1 ] }}
                </div>
              </template>
            </div>
          </transition>
        </div>
        <div class="inc" @click="monthInc( 1 )"></div>
      </div>
      <div class="current" title="установить текущую дату" @click="setByCur()"></div>
      <div class="year">
        <div class="dec" @click="yearInc( -1 )"></div>
        <div
          class="val"
          :class="year == dateCur.year ? 'current' : ''"

          @click="selector='years'"
        >
          {{ year }}
          <transition
            name="selector"
          >
            <div class="selector years" ref="years" v-show="selector=='years'">
              <template v-for="n in [ year - 3, year - 2, year - 1, year, year + 1, year + 2, year + 3 ]">
                <div
                  :class="n == year ? 'current' : ''"
                  @click.stop="yearSet( n)"
                >{{ n }}</div>
              </template>
            </div>
          </transition>
        </div>
        <div class="inc" @click="yearInc( 1 )"></div>
      </div>
    </div>

    <table class="days" valign="top" align="center" cellspacing="0" cellpadding="0">
      <caption></caption>
      <tr>
        <th
          scope="col"

          v-for="d in 7"
          :class="holidayIs( d ) ? 'holiday' : ''"
        >{{ moFirst ? weekDayNames[ d - 1 ] : weekDayNames[ d == 1 ? 6 : d - 2 ] }}</th>
      </tr>

      <tr class="divider"><td colspan="7"><div /></td></tr>

      <tr v-for="y in 6">
        <td
          v-for="x in 7"
          class="day"
          :class="{ holiday: holidayIs( x ), edge: days[ y - 1 ][ x - 1 ].month != month, current: !!days[ y - 1 ][ x - 1 ].current, selected: !!days[ y - 1 ][ x - 1 ].selected }"
          @click="setBy( { ...days[ y - 1 ][ x - 1 ], hours, minutes, seconds } )"
        >{{ days[ y - 1 ][ x - 1 ].day }}</td>
      </tr>
    </table>

    <div class="time" v-if="timeUse">
      <div class="hours">
        <div class="inc" @click="hoursInc( 1 )"></div>
        <div class="val">{{ pad2( hours ) }}</div>
        <div class="dec" @click="hoursInc( -1 )"></div>
      </div>
      <div class="minutes">
        <div class="inc" @click="minutesInc( 1 )"></div>
        <div class="val">{{ pad2( minutes ) }}</div>
        <div class="dec" @click="minutesInc( -1 )"></div>
      </div>
      <div class="seconds" v-if="secondsUse">
        <div class="inc" @click="secondsInc( 1 )"></div>
        <div class="val">{{ pad2( seconds ) }}</div>
        <div class="dec" @click="secondsInc( -1 )"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from "./Icon";
import dates from "@/dates"

const dateCur = () => {
    const d = new Date();

    return {
      year:   d.getFullYear(),
      month:  d.getMonth() + 1,
      day:    d.getDate(),
      hours:  d.getHours(),
      minutes:d.getMinutes(),
      seconds:d.getSeconds(),
      d
    };
};

export default {
	components: {
		Icon
	},
	name: "Calendar",

  props: {
	  value: {
	    type: String,
      value: ""
    },

	  moFirst: {
	    type: Boolean,
      default: true
    },

    y4: {
	    type: Boolean,
      default: true
    },

    timeUse: {
	    type: Boolean,
      default: true
    },

    secondsUse: {
	    type: Boolean,
      default: true
    },
	},

  i18n: {
    messages: {
      ru: {
        Mo: "Пн",
        Tu: "Вт",
        We: "Ср",
        Th: "Чт",
        Fr: "Пт",
        Sa: "Сб",
        Su: "Вс",

        Jan: "Январь",
        Feb: "Февраль",
        Mar: "Март",
        Apr: "Апрель",
        May: "Май",
        Jun: "Июнь",
        Jul: "Июль",
        Aug: "Август",
        Sep: "Сентябрь",
        Oct: "Октябрь",
        Nov: "Ноябрь",
        Dec: "Декабрь"
      },

      en: {
        Mo: "Mo",
        Tu: "Tu",
        We: "We",
        Th: "Th",
        Fr: "Fr",
        Sa: "Sa",
        Su: "Su",

        Jan: "January",
        Feb: "February",
        Mar: "March",
        Apr: "April",
        May: "May",
        Jun: "June",
        Jul: "July",
        Aug: "August",
        Sep: "September",
        Oct: "October",
        Nov: "November",
        Dec: "December"
      },

      kz: {
        Mo: "Дү",
        Tu: "Се",
        We: "Сә",
        Th: "Бе",
        Fr: "Жұ",
        Sa: "Се",
        Su: "Же",

        Jan: "Қаңтар",
        Feb: "Ақпан",
        Mar: "Наурыз",
        Apr: "Сәуір",
        May: "Мамыр",
        Jun: "Маусым",
        Jul: "Шілде",
        Aug: "Тамыз",
        Sep: "Қыркүйек",
        Oct: "Қазан",
        Nov: "Қараша",
        Dec: "Желтоқсан"
      }
    }
  },

	data() {
	  let d = {};
	  try {
	    d = dates.format( this.value, this.y4 ? dates.types.RUS4Y : dates.types.RUS, dates.types.STRUCT, true, true );
    }
    catch ( e ) {}

	  const dp = {
        day:    d.day,
        month:  d.month,
        year:   d.year,
        hours:  d.hours,
        minutes:d.minutes,
        seconds:d.seconds,
    };
	  if ( dp.day === undefined ) {
	    const d = dateCur();
	    dp.day    = d.day;
	    dp.month  = d.month;
	    dp.year   = d.year;
    }
	  if ( dp.hours === undefined ) {
	    const d  = dateCur();
	    dp.hours  = d.hours;
	    dp.minutes= d.minutes;
	    dp.seconds= d.seconds;
    }

		return {
		  ...dp,

      selected: structuredClone( dp ),

      selector: null
		};
	},

  mounted() {
	  const h = e => {
	    if ( this.selector && e ) {
	      if ( e.type == "keydown" ) {
          if ( e.key === "Escape" ) {
            this.selector = null;
            e.cancelBubble = true;
            return false;
          }
        }
	      else if ( e.type == "mousedown" ) {
	        const el = this.$refs[ this.selector ];
	        if ( el && !el.contains( e.target ) ) {
            this.selector = null;
            e.cancelBubble = true;
            return false;
          }
        }
      }
    };
    this.$options.seHandler = h;

	  document.addEventListener( "keydown", h );
	  document.addEventListener( "mousedown", h );
  },
  beforeUnmount() {
	  if ( this.$options.seHandler ) {
  	  document.removeEventListener( "keydown", this.$options.seHandler );
	    document.removeEventListener( "mousedown", this.$options.seHandler );
	    this.$options.seHandler = null;
    }
  },

	methods: {
    pad2( n ) {
      return String( n ).padStart( 2, "0" );
    },
	  holidayIs( weekDay ) {
    	return this.moFirst ? ( weekDay == 6 || weekDay == 7 ) : ( weekDay == 1 || weekDay == 7 );
    },

    hideAll() {
      this.selector = null;
    },
    yearSet( v ) {
      this.hideAll();
      this.year = v;
    },
    yearInc( v ) {
      this.hideAll();
      this.year += v;
    },
    monthSet( v ) {
      this.hideAll();
      this.month = v;
    },
    monthInc( v ) {
      this.hideAll();
      let t = this.month + v;
      if ( t > 12 ) {
        this.year++;
        t = t % 12;
      }
      else if ( t <= 0 ) {
        this.year--;
        t = 12 + ( t % 12 );
      }

      this.month = t;
    },
    hoursInc( v ) {
      this.hideAll();
      let t = ( this.hours + v ) % 24;
      if ( t < 0 ) t = 24 + t;
      this.hours = t;
    },
    minutesInc( v ) {
      this.hideAll();
      let t = ( this.minutes + v ) % 60;
      if ( t < 0 ) t = 60 + t;
      this.minutes = t;
    },
    secondsInc( v ) {
      this.hideAll();
      let t = ( this.seconds + v ) % 60;
      if ( t < 0 ) t = 60 + t;
      this.seconds = t;
    },

    setByCur() {
      this.year  = this.dateCur.year;
      this.month = this.dateCur.month;
      this.day   = this.dateCur.day;
      this.hours = this.dateCur.hours;
      this.minutes  = this.dateCur.minutes;
      this.seconds  = this.dateCur.seconds;

      this.selected = {
        year: this.year,
        month:this.month,
        day:  this.day,
        hours:this.hours,
        minutes: this.minutes,
        seconds: this.seconds,
      }
    },

    setBy( day, month, year, hours, minutes, seconds ) {
      if ( arguments.length == 1 && typeof( day ) == "object" ) {
        month   = day.month;
        year    = day.year;
        hours   = day.hours;
        minutes = day.minutes;
        seconds = day.seconds;
        day     = day.day;
      }

      this.selected = {
        day,
        month,
        year,
        hours,
        minutes,
        seconds
      };
    },

    dateFormat( day, month, year, hours, minutes, seconds, timeUse, secondsUse ) {
      if ( !hours ) hours = 0;
      if ( !minutes ) minutes = 0;
      if ( !seconds ) seconds = 0;

      let d = this.pad2( day ) + "." + this.pad2( month ) + "." + year;
      if ( timeUse ) {
        d += " " + this.pad2( hours ) + ":" + this.pad2( minutes );
        if ( secondsUse ) d += ":" + this.pad2( seconds );
      }

      return d;
    }
  },

  computed: {
    dateCur() {
      return dateCur();
    },

	  date() {
	    const d = new Date();
	    d.setFullYear( this.year, this.month - 1, this.day );
	    d.setHours( this.hours, this.minutes, this.seconds );

	    return {
        year: d.getFullYear(),
        month:d.getMonth() + 1,
        day:  d.getDate(),
        seconds: d.getSeconds(),
        minutes: d.getMinutes(),
        hours:d.getHours(),
        d
      };
    },

	  days() {
	    const days = new Array( 6 );

	    const dc = this.dateCur;
	    
	    const d = new Date( this.year, this.month - 1, 1 );
	    let msd = d.getDay() - 1;
	    if ( msd == -1 ) msd = 6;

	    if ( !this.moFirst ) {
	      if ( msd == 6 ) msd = 0;
	      else msd++;
      }

	    d.setTime( d.getTime() - msd * 86400000 );

	    for ( let y = 0; y < 6; y++ ) {
	      days[ y ] = new Array( 7 );

	      for ( let x = 0; x < 7; x++ ) {
	        const year  = d.getFullYear();
	        const month = d.getMonth() + 1;
	        const day   = d.getDate();

	        const item = {
            year,
            month,
            day
          };

	        if ( year == dc.year && month == dc.month && day == dc.day ) item.current = true;
	        if ( year == this.selected.year && month == this.selected.month && day == this.selected.day ) item.selected = true;

	        days[ y ][ x ] = item;

	        d.setDate( day + 1 );
        }
      }

	    return days;
    },

    dateCalAsTxt() {
      return this.dateFormat( this.day, this.month, this.year, this.hours, this.minutes, this.seconds, this.timeUse, this.secondsUse );
    },

    weekDayNames() {
      return [ "Mo", "Tu", "We", "Th", "Fr", "Sa", "Su" ].map( i => this.$t( i ) );
    },
    monthNames() {
      return [ "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec" ].map( i => this.$t( i ) );
    }
  },

  watch: {
	  dateCalAsTxt() {
	    this.$emit(
	      "dateChange",
        {
          day:    this.day,
          month:  this.month,
          year:   this.year,
          hours:  this.hours,
          minutes:this.minutes,
          seconds:this.seconds,
          asTxt:  this.dateFormat( this.day, this.month, this.year, this.hours, this.minutes, this.seconds, this.timeUse, this.secondsUse )
        }
      );
    },
    selected: {
	    deep: true,
      handler() {
        this.$emit(
          "input",
          {
            ...this.selected,
            asTxt:this.dateFormat( this.selected.day, this.selected.month, this.selected.year, this.selected.hours, this.selected.minutes, this.selected.seconds, this.timeUse, this.secondsUse )
          }
        );
      }
    }
  }
};
</script>

<style scoped>
.main {
  background-color: #FAFAFA;
  padding: 0.5em;
  border-radius: 0.2em;
  box-shadow: 0 0 2px 1px #C0C0C0;
  display: inline-block;
  font-family: Verdana;
  font-size: 0.8em;
  color: #000000;
}

/* DAYS */
.holiday {
  color: #8E5535;
}

.days th,
.days td {
  width: 2.5em;
  text-align: center;
  border-radius: 0.2em;
}

.days td.day {
  cursor: pointer;
  border: solid 1px transparent;
  vertical-align: middle;
  height: 1em;
  line-height: 1.5em;
}
.days td.day:hover {
  border-color: #000000;
}

.days th {
  font-weight: bold;
}

.edge {
  opacity: 0.5;
}
.current {
  font-weight: bold;
}
.selected {
  background-color: #000000;
  color: #FFFFFF;
}
.days .divider td {
  padding: 0.2em 0;
}
.days .divider td div {
  height: 1px;
  background-color: #D0D0D0;
}

/* TIME */
.time {
  text-align: center;
  border: dotted #000000;
  border-width: 1px 0 0 0;
  margin-top: 0.5em;
  padding-top: 0.5em;
}
.time .hours,
.time .minutes,
.time .seconds {
  display: inline-block;
  position: relative;
  font-size: 2.5em;
  padding: 0 0.3em;
}
.time .minutes .val:before,
.time .seconds .val:before {
  position: absolute;
  left: -0.12em;
  content: ":";
}

.time .hours .val,
.time .minutes .val,
.time .seconds .val {
  vertical-align: middle;
  width: 1.5em;
  overflow: hidden;
}

.time .inc,
.time .dec {
  position: relative;
  height: 0.3em;
  cursor: pointer;
  transition: all .2s linear;
  opacity: 0.5;
}
.time .inc:hover,
.time .dec:hover {
  opacity: 1;
}

.time .inc:after,
.time .dec:after {
  content: "";
  display: inline-block;
  position: absolute;
  width: 0;
  height: 0;
  line-height: 0;
  border-style: solid;
  left: 50%;
  transform: translate( -50%, 0 );
}

.time .dec:after {
  bottom: 0;
  border-width: 0.3em 0.3em 0 0.3em;
  border-color: #000000 transparent transparent transparent;
}
.time .inc:after {
  top: 0;
  border-width: 0 0.3em 0.3em 0.3em;
  border-color: transparent transparent #000000 transparent;
}

/* MONTHYEAR */
.monthyear {
  margin-bottom: 1em;
}
.monthyear,
.monthyear > .month,
.monthyear > .year {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  text-align: center;
}
.monthyear > *,
.monthyear > .month > *,
.monthyear > .year > * {
  flex-grow: 0;
  flex-shrink: 0;
  border-radius: 0.2em;
}
.monthyear > .month > .val,
.monthyear > .year > .val {
  transition: all .2s linear;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
}
.monthyear > .month > .val {
  width: 6em;
}
.monthyear > .year > .val {
  width: 3em;
}
.monthyear > .month > .val:hover,
.monthyear > .year > .val:hover {
  background-color: #BFBFBF;
}
.monthyear > .month.current > .val,
.monthyear > .year.current > .val {
  font-weight: bold;
}

.monthyear > .current {
  width: 1em;
}

.monthyear .inc,
.monthyear .dec {
  position: relative;
  width: 1em;
  height: 1em;
  margin: 0 0.5em;
  transition: all .2s linear;
  opacity: 0.5;
  cursor: pointer;
}
.monthyear .inc:hover,
.monthyear .dec:hover {
  opacity: 1;
}
.monthyear .inc:after,
.monthyear .dec:after {
  content: "";
  position: absolute;
  top: 0;
  width: 0;
  height: 0;
  border-style: solid;
}
.monthyear .inc:after {
  left: 0.175em;
  border-width: 0.5em 0 0.5em 0.5em;
  border-color: transparent transparent transparent #000000;
}
.monthyear .dec:after {
  right: 0.175em;
  border-width: 0.5em 0.5em 0.5em 0;
  border-color: transparent #000000 transparent transparent;
}

.selector {
  position: absolute;
  z-index: 1;

  background-color: #FAFAFA;
  padding: 0.5em;
  border-radius: 0.2em;
  box-shadow: 0 0 2px 1px #C0C0C0;
  font-weight: normal;
}
.selector > div {
  text-align: left;
  border-radius: 0.2em;
  padding: 0 0.2em;
  transition: all .2s linear;
}
.selector > div:hover {
  background-color: #BFBFBF;
}
.selector > div > span {
  color: #8D8D8D;
  padding-right: 0.2em;
}

.selector-enter-active,
.selector-leave-active {
  opacity: 1;
  transition: opacity .2s linear;
}
.selector-enter,
.selector-leave-to {
  opacity: 0;
}

.monthyear .selector.months {
  width: 16em;
}
.monthyear .selector.months > div {
  display: inline-block;
  width: 7.5em;
}
.monthyear .selector.months > div > span {
  color: #8D8D8D;
  padding-right: 0.2em;
}

.monthyear .selector.years > div {
  text-align: center;
}

.monthyear > .current {
  width: 1em;
  height: 1em;
  position: relative;
  transition: opacity .2s linear;
  opacity: 0.5;
  cursor: pointer;
}
.monthyear > .current:after {
  content: "";
  position: absolute;
  top: 0.25em;
  left: 0.25em;
  background-color: #000000;
  border-radius: 100%;
  width: 0.5em;
  height: 0.5em;
}
.monthyear > .current:hover {
  opacity: 1;
}
</style>
